export const benefitsTranslate = {
    es : {
        title: "Viva Fan mejoró",
        subtitle: "Disfruta de tarifas aún más bajas y beneficios exclusivos.",
        tabs: {
            discount :{
                tab: 'Descuentos',
                title: 'Tarifas aún más bajas y promociones especiales',
                content : 'Ahorra hasta $400 MXN en vuelos nacionales y hasta $20 USD en internacionales. Además, disfruta de promociones especiales.'
            },
            addiotional :{
                tab: 'Beneficios adicionales',
                title: "Obtén hasta 7kg de equipaje documentado en SMART. Además, documenta tu equipaje y aborda con reconocimiento facial.",
                content: "Además, tu proceso de check-in y abordaje será tan sencillo como sonreír."
                // title: 'Añade peso adicional sin costo a tu maleta y utiliza Smile & Fly para abordar y documentar más fácil',
                // content : 'Viaja con 5 kg de peso adicional sin costo, en equipaje documentado o maleta de mano, en combos Extra y Smart Además, tu proceso de check-in y abordaje será tan sencillo como sonreír.'
            },
            companions :{
                tab: 'Acompañantes',
                title: 'Viaja con quien quieras',
               // content : 'Añade hasta 8 amigos o familiares con Viva Fan Team para que disfruten el beneficio de descuento en tarifas.'
               content: "Añade hasta 8 amigos o familiares para que disfruten del beneficio de descuento en tarifas."
            },
        }
    },
    eng : {
        title: "Viva Fan has gotten even better",
        subtitle: "Now you can enjoy even lower rates and exclusive benefits.",
        tabs: {
            discount :{
                tab: 'Discounts',
                title: 'Even lower fares and special promotions',
                content : 'Save up to $400 MXN on domestic flights and up to $20 USD on international flights. Also, enjoy special promotions.'
            },
            addiotional :{
                tab: 'Additional benefits',
                title: 'Up to 7kg of checked luggage in SMART. And, check your luggage and board with facial recognition.',
                content : 'In Extra and Smart, travel with 11 lbs (5 kg) or 15 lbs (7 kg) of additional weight at no cost in checked baggage or your carry-on.'
            },
            companions :{
                tab: 'Companions',
                title: 'Travel with whoever you want',
                //content : 'Add up to 8 friends or family with Viva Fan Team to enjoy the benefit of discounted rates.'
                content: "Travel with whoever you want. Add up to 8 friends or family members to enjoy discounted fares."
            },
        }
    }
}